import React, { HTMLAttributes } from 'react'
import { Spinner } from './ButtonSpinner';


const baseClasses = 'inline-flex items-center justify-center font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';

const variants = {
    primary: "bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500",
    secondary: "bg-purple-600 hover:bg-purple-700 text-white focus:ring-purple-500",
    danger: "bg-red-600 hover:bg-red-700 text-white focus:ring-red-500",
    gray: "bg-gray-200 hover:bg-gray-300 text-gray-800",
    outline: 'border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 focus:ring-blue-500'
};

const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base'
};
type buttonType = "submit" | "button"
type Props = HTMLAttributes<HTMLButtonElement> & {
    loading?: boolean;
    disabled?: boolean;
    type: buttonType;
    loadingText?: string;
    className?: string
    variant?: keyof typeof variants;
    size?: keyof typeof sizes;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}
function Button({ loading, disabled, type, loadingText = "Loading...", variant = "primary", size = "md", className, onClick, children, ...props }: Props) {
    return (
        <button
            className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
            disabled={disabled || loading}
            onClick={onClick}
            {...props}
        >
            {loading && <Spinner />}
            {loading ? loadingText : children}
        </button>
    )
}

export default Button
